import { useState, useEffect } from 'react';
import { api } from '../api/client';

const GROUPS = [
  {
    title: 'Bannière (hero)',
    fields: [
      { key: 'hero.title', label: 'Titre', type: 'text' },
      { key: 'hero.paragraph', label: 'Paragraphe', type: 'textarea' }
    ]
  },
  {
    title: 'Titres de sections',
    fields: [
      { key: 'section.features_title', label: 'Titre "Expertise"', type: 'text' },
      { key: 'section.formation_title', label: 'Titre "Formations"', type: 'text' },
      { key: 'section.products_title', label: 'Titre "Produits"', type: 'text' },
      { key: 'section.partners_title', label: 'Titre "Ils parlent de nous"', type: 'text' },
      { key: 'section.testimonials_title', label: 'Titre "Témoignages"', type: 'text' }
    ]
  },
  {
    title: 'Formations',
    fields: [
      { key: 'formation.intro', label: 'Texte d\'introduction', type: 'textarea' }
    ]
  },
  {
    title: 'Pied de page',
    fields: [
      { key: 'footer.company_name', label: 'Nom de la société', type: 'text' },
      { key: 'footer.owner_name', label: 'Nom du responsable', type: 'text' },
      { key: 'footer.address', label: 'Adresse', type: 'text' },
      { key: 'footer.phone', label: 'Téléphone', type: 'text' },
      { key: 'footer.email', label: 'Email', type: 'text' },
      { key: 'footer.whatsapp_link', label: 'Lien WhatsApp (https://wa.me/...)', type: 'text' }
    ]
  }
];

function SiteSettingsManager() {
  const [settings, setSettings] = useState({});
  const [logoUrl, setLogoUrl] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    api.getSettings().then((data) => {
      setSettings(data);
      setLogoUrl(data['branding.logo_url'] || '');
    }).catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const handleLogoChange = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const { url } = await api.upload('misc', file);
      setLogoUrl(url);
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  const save = async () => {
    setSaving(true);
    setSuccess('');
    setError('');
    try {
      const payload = {
        ...settings,
        'branding.logo_url': logoUrl
      };
      await api.updateSettings(payload);
      setSuccess('Modifications enregistrées.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="admin-panel"><p>Chargement…</p></div>;

  return (
    <div className="admin-panel">
      <div className="admin-panel-header">
        <h2>Paramètres du site</h2>
      </div>
      {error && <div className="admin-error">{error}</div>}
      {success && <div className="admin-success">{success}</div>}

      <div className="admin-form">
        <div className="admin-form-row">
          <label>Logo</label>
          <div>
            {logoUrl && <img src={logoUrl} alt="" className="admin-image-preview" />}
            <input type="file" accept="image/*" onChange={(e) => handleLogoChange(e.target.files[0])} />
            {uploading && <span> Envoi en cours…</span>}
          </div>
        </div>
      </div>

      {GROUPS.map((group) => (
        <div key={group.title} className="admin-settings-group">
          <h3>{group.title}</h3>
          <div className="admin-form">
            {group.fields.map((f) => (
              <div className="admin-form-row" key={f.key}>
                <label>{f.label}</label>
                {f.type === 'textarea' ? (
                  <textarea
                    rows={4}
                    value={settings[f.key] || ''}
                    onChange={(e) => setSettings((prev) => ({ ...prev, [f.key]: e.target.value }))}
                  />
                ) : (
                  <input
                    type="text"
                    value={settings[f.key] || ''}
                    onChange={(e) => setSettings((prev) => ({ ...prev, [f.key]: e.target.value }))}
                  />
                )}
              </div>
            ))}
          </div>
        </div>
      ))}

      <div className="admin-form-actions">
        <button className="admin-btn admin-btn-primary" onClick={save} disabled={saving}>
          {saving ? 'Enregistrement…' : 'Enregistrer'}
        </button>
      </div>
    </div>
  );
}

export default SiteSettingsManager;
